export function usePropertyHelper() {
    function getProperty(properties: any[], code: string): { value: any; value_code: string } {
        return properties?.find((property) => {
            return property.attribute?.code === code;
        });
    }

    return {
        getProperty,
    };
}
